export default {
  extraSmall: 640,
  small: 860,
  medium: 1024,
  large: 1220,
  extraLarge: 1440
};
